import { GridAction } from '@eforall/dashboard';
import { EntrepreneurProspectCourse } from '@interfaces';

export function getActions() {

	const actions: GridAction<EntrepreneurProspectCourse>[] = [
		// {
		// 	iconClass: 'fa-regular fa-pencil',
		// 	label: 'View',
		// 	isEnabled: rows => !!rows.length,
		// 	execute: async rows => { console.log(`Action clicked!`, rows) }
		// },
	];

	return actions;
}